import { NewFile } from '@askporter/grieg-types';
import { captureException } from '@sentry/react';
import { API } from '../../services/API';
import { UploadedFile } from '../../types';

export default async (filesToUpload: Array<File>): Promise<Array<UploadedFile>> => {
  return Promise.all(
    filesToUpload.map(async (file) => {
      try {
        const payload: NewFile = { pathPrefix: '/', filename: file.name, sensitive: true };

        const {
          data: { uid, urn, signedUploadPath },
        } = await API.post({ path: 'files', payload });

        await API.put({ path: signedUploadPath, payload: file, authHeader: false, isGrieg: false });
        return { uid, urn, name: file.name, signedUploadPath, addedAt: new Date().toISOString() };
      } catch (error) {
        captureException(error, { extra: { fileName: file?.name, response: error?.response?.data?.message } });
        return { name: file?.name, error };
      }
    }),
  );
};
